import { useEffect, useRef, useSyncExternalStore } from "react";
import {
  getMonitoringProcessingStatus,
  isBusyStatus,
  subscribeMonitoringProcessing,
  subscribeMonitoringProcessingFinished,
  type MonitoringProcessingStatus,
} from "@/src/services/monitoring_processing_store";

export function useMonitoringProcessingStatus(): MonitoringProcessingStatus {
  return useSyncExternalStore(
    subscribeMonitoringProcessing,
    getMonitoringProcessingStatus,
    getMonitoringProcessingStatus,
  );
}

export function useMonitoringProcessing(): boolean {
  return isBusyStatus(useMonitoringProcessingStatus());
}

export function useOnMonitoringProcessingFinished(onFinished: () => void): void {
  const onFinishedRef = useRef(onFinished);

  useEffect(() => {
    onFinishedRef.current = onFinished;
  });

  useEffect(() => subscribeMonitoringProcessingFinished(() => onFinishedRef.current()), []);
}
